export const buildInfo = {
  buildVersion: '6.0.43',
  buildDate: 1683241846950,
};
